import Horn from '@mtfe/horn-sdk';
import Vue from 'vue';

const options: any = {
  sankuaiOnly: false,
  isDev: process.env.CONFIG_ENV !== 'production',
};
Horn.init({}, options);
(window as any).$Horn = Horn;

Vue.mixin({
  computed: {
    Horn() {
      return Horn;
    },
  },
});
declare module 'vue/types/vue' {
  interface Vue {
    Horn: any;
  }
}
